// extracted by mini-css-extract-plugin
export var currencyInput = "_l8-1";
export var currencySymbol = "_l8-0";